var _path, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcoClock(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 34.111,
    height: 34.111,
    viewBox: "0 0 34.111 34.111",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.056,0A17.056,17.056,0,1,0,34.111,17.056,17.075,17.075,0,0,0,17.056,0Zm0,31.621A14.566,14.566,0,1,1,31.621,17.055,14.582,14.582,0,0,1,17.056,31.621Z",
    fill: "#646665"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(14.981 8.341)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M232.742,133.912h-5.395v-7.47a1.245,1.245,0,1,0-2.49,0v8.715A1.245,1.245,0,0,0,226.1,136.4h6.64a1.245,1.245,0,1,0,0-2.49Z",
    transform: "translate(-224.857 -125.197)",
    fill: "#646665"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoClock);
export default __webpack_public_path__ + "static/media/ico-clock.46eca77a04e0451e76705ffa4f627293.svg";
export { ForwardRef as ReactComponent };